export default {
  colors: {
    kelp: '#255c59',
    sand: '#dcdcdc',
    white: '#fff',
  },
  fontSizes: {
    body: '14px',
    subtitle: '28px',
    title: '48px',
  },
  spacings: {
    0: '0px',
    1: '4px',
    2: '8px',
    3: '16px',
    4: '24px',
    5: '32px',
    6: '48px',
  },
} as const;
